module.exports = __webpack_public_path__ + "static/img/cover-image-3.ee9df78.png";